import React from 'react';
import { Box, Text, Heading } from 'wt-ui';

const str = `
Short & Leveraged Exchange-Traded Products are only intended for investors who understand the risks involved in investing in a product with short
and/or leveraged exposure and who intend to invest on a short-term basis. 
Any investment in short and/or leveraged products should be monitored on a regular basis (as frequently as daily) to 
ensure consistency with your investment strategy. You should understand that investments in short and/or leveraged 
exchange-traded products held for a period of longer than one day may not provide returns equivalent to the return from the 
relevant unleveraged investment multiplied by the relevant leverage factor. Potential losses in short and/or leveraged exchange-traded 
products may be magnified in comparison to investments that do not incorporate these strategies. Please refer to the section entitled
“Risk Factors” in the relevant prospectus for further details of these and other risks associated with an investment in short and/or
leveraged exchange-traded products. You should consult an independent investment adviser prior to making an investment in
short and/or leveraged exchange-traded products in order to determine suitability to your circumstances.
`;

const Disclaimer = () => (
  <Box background="transparent" style={{ marginTop: '40px' }}>
    <Heading level={4}>Important information:</Heading>
    <Text>{str}</Text>
  </Box>
);

export default Disclaimer;
